
import { React, useState, useEffect, useContext, useRef } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faL, faMagnifyingGlass, faPrint, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf } from '@fortawesome/free-regular-svg-icons'
import { useSelector } from 'react-redux';
import { faTriangleExclamation, faStar, faCircleInfo, faXmark, faPlus, faMinus, faPencil, faFloppyDisk } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, CommonAPIConstants, EditCPTConstants, MacroConstants } from '../utilities/Constants'
import Draggable from 'react-draggable'
import * as XLSX from 'xlsx';
import { useParams, useLocation, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import { counter, parse } from '@fortawesome/fontawesome-svg-core'
import DatePicker from 'react-datepicker';
import { format, set } from 'date-fns';




const EditCpt = () => {

    const navigate = useNavigate();



    const userData = useSelector((state) => state.user.user);

    localStorage.setItem('userData', JSON.stringify(userData));

    const { id } = useParams();

    const location = useLocation();

    const { state } = useLocation();



    const data = state?.claimDetails ? JSON.stringify(state.claimDetails) : "{}";
    const claimData = state?.claimDetails ? JSON.parse(state.claimDetails) : {};

    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;

    const sAuthToken = useSelector((state) => state.user.token);

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('2015-01-01');

    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(''); // State to store start date
    const [endDate, setEndDate] = useState('');     // State to store end date
    const [loading, setLoading] = useState(true);

    const [appointmentDate, setAppointmentDate] = useState('');

    const [selectedCMS33a, setSelectedCMS33a] = useState('');
    const [selectedCMS33b, setSelectedCMS33b] = useState('');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('');
    const [selectedService, setSelectedService] = useState('');

    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);

    const [tableDetails, setTableDetails] = useState([]);



    const [patientList, setPatientList] = useState('');
    const [hasFetched, setHasFetched] = useState(false);

    const [selectedCPTCode, setSelectedCPTCode] = useState([]);



    const [searchByCPT, setSearchByCPT] = useState('');
    const [searchByDescription, setSearchByDescription] = useState('');
    const [searchByFee, setSearchByFee] = useState('');
    const [searchByCharges, setSearchByCharges] = useState('');

    const [searchByService, setSearchByService] = useState('');
    const [searchByBox32a, setSearchByBox32a] = useState('');
    const [searchByBox33a, setSearchByBox33a] = useState('');
    const [searchByBox33b, setSearchByBox33b] = useState('');

    const [selectedCptValue, setSelectedCptValue] = useState('');

    const [isSuggestionSelected, setIsSuggestionSelected] = useState(false);

    const [cptValueList, setCptValueList] = useState([]);

    const [selectedUnitValue, setSelectedUnitValue] = useState('');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showApprovalSaveModal, setShowApprovalSaveModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [showPaidErrorModal, setShowPaidErrorModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [showFaxModal, setShowFaxModal] = useState(false);

    const [successTimer, setSuccessTimer] = useState(5000);


    const [errorMessage, setErrorMessage] = useState(false);


    const [syncedValue, setSyncedValue] = useState('');
    const [syncedUnitchargeVal, setSyncedUnitchargeVal] = useState('');

    const [activeRow, setActiveRow] = useState(null);

    const [cptdescription, setCptDescription] = useState('');
    const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);
    const [total, setTotal] = useState(0);
    const [cptCharges, setCptCharges] = useState('');
    const [editRows, setEditRows] = useState([]);
    const [editableRow, setEditableRow] = useState(null);

    const [box32AData, setBox32AData] = useState([]);
    const [CPTServiceData, setCPTServiceData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [selectDescription, setselectDescription] = useState('');
    const [selectProjectedFee, setselectProjectedFee] = useState('');
    const [selectCharges, setselectCharges] = useState('');
    const [IsDuplicateCPT, setIsDuplicateCPT] = useState([]);

    const [showEnableUnitModal, setShowEnableUnitModal] = useState(false);
    const [showDisableUnitModal, setShowDisableUnitModal] = useState(false);
    const [selectedUnitItem, setSelectedUnitItem] = useState(null);

    useEffect(() => {
        document.title = 'Edit CPT'


        let timerId;

        if (showSuccessModal || showDeleteModal || showConfirmSaveModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setShowDeleteModal(false);
                setShowConfirmSaveModal(false);
            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, showDeleteModal, showConfirmSaveModal]);







    const getMonths = (selectedYear) => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();

        return Array.from({ length: 12 }, (v, k) => {
            if (selectedYear === currentYear && k > currentMonth) {
                return null;
            }
            return (
                <option key={k} value={k}>
                    {format(new Date(selectedYear, k), 'MMMM')}
                </option>
            );
        }).filter(option => option !== null);
    };







    const handleToAppointmentDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setAppointmentDate(formattedDate);
            console.log("Selected start date:", formattedDate);
        } else {
            setAppointmentDate(null);
        }
    };






    const handleFromDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setStartDate(formattedDate);
            console.log("Selected start date:", formattedDate);
        } else {
            setStartDate(null);
        }
    };




    const handleToDateChange = (date) => {
        if (date) {
            const formattedDate = format(date, 'MM/dd/yyyy');
            setEndDate(formattedDate);
            console.log("Selected start date:", formattedDate);
        } else {
            setEndDate(null);
        }
    };








    const isValidDate = (dateString) => {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        return dateString.match(regEx) !== null;
    };





    const formatDOSDate = (dateString) => {
        if (!dateString) return ''; // Return empty string if dateString is falsy

        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return ''; // Return empty string if date is invalid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };











    // Fetch CPT list based on user input

    const fetchSearchCPTList = (index, value) => {
        if (!selectedCptValue) {
            setCptValueList([]);
            return;
        }

        console.log('Selected suggestion:', selectedCptValue);

        var inputJSON = {
            PracticeID: userPracticeID,
            SearchKey: selectedCptValue,
        };


        var sJSONInput = JSON.stringify(inputJSON);
        console.log("input of" + CommonAPIConstants.GetAllCPTList, inputJSON);

        const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllCPTList}?sInputJSON=${sJSONInput}`;

        console.log("URL: ", url);

        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.status != 200) {
                    console.log("response.status", response.status);
                } else return response.json();
            })
            .then((data) => {
                const cptData = JSON.parse(data);


                const filteredCPTData = cptData.filter(
                    (item) => `${item.CPTCode} ${item.CPTDesc}` !== selectedCptValue
                );

                setCptValueList(filteredCPTData);
                console.log("filteredCPTData :", filteredCPTData)


            })
            .catch((error) => {
                console.error('Error fetching CPT names:', error);
            });
    };




    useEffect(() => {
        if (!isSuggestionSelected) {
            fetchSearchCPTList(selectedCptValue);
        } else {
            setIsSuggestionSelected(false);
        }
    }, [selectedCptValue]);



    const handleCPTList = (suggestion) => {
        setSelectedCptValue(`${suggestion.CPTCode}`);
        setSelectedCPTCode(`${suggestion.CPTCode}`);
        setCptDescription(`${suggestion.CPTDesc}`)
        setCptCharges(`${suggestion.UnitCharge}`)

        handleCheckIsDuplicateCPT(suggestion.CPTCode)
        setCptValueList([]);
        setSelectedUnitValue(1);
        const billingFee = parseFloat(suggestion.UnitCharge).toFixed(2);
        setSyncedUnitchargeVal(billingFee);
        setSyncedValue(billingFee)
        setIsSuggestionSelected(true);
        console.log('Selected suggestion:', billingFee);
    };


    const handleCPTKeyDown = (e) => {
        if (e.key === 'Backspace') {
            // Handle backspace key
            if (selectedCptValue === '' && cptValueList.length > 0) {
                // If input is empty and there are suggestions, remove the entire list
                setCptValueList([]);


            } else {
                // If input is not empty, dynamically filter suggestions based on the current input
                fetchSearchCPTList(selectedCptValue.slice(0, -1)) // Remove the last character from searchText

            }
        }
    }




    const resetDialogValues = () => {

        setSelectedCptValue('');
        setCptDescription('');
        setCptCharges('')

    };





    const handleCheckIsDuplicateCPT = async (cptcode) => {


        const inpuJson = {

            sCPTCode: cptcode,
            sPracticeID: userPracticeID,

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + EditCPTConstants.CheckIsDuplicateCPT, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + EditCPTConstants.CheckIsDuplicateCPT, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();
            setIsDuplicateCPT(responseData)

            if (responseData > 0) {
                setShowSelectErrorModal(true)
            }

            console.log("Response" + EditCPTConstants.CheckIsDuplicateCPT, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };




    const handleSaveCPTData = async () => {

        if (IsDuplicateCPT === 1) {
            setShowConfirmSaveModal(true);
            return;
        }

        const inputJson = {

            sPracticeID: userPracticeID,
            sUserID: userId,
            sCPTCode: selectedCptValue,
            sCPTDesc: cptdescription,
            sBillingFee: cptCharges

        }



        const myInput = JSON.stringify(inputJson);
        const sInputJSON = JSON.stringify(myInput);
        console.log("inputRow of" + EditCPTConstants.SaveNewCPTtoList, sInputJSON);


        try {


            const response = await fetch(APIConstants.BASE_URL_BILLING + EditCPTConstants.SaveNewCPTtoList, {
                method: 'POST',


                headers: {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },

                body: sInputJSON
            })


            if (response.ok) {
                const responseData = await response.json();

                if (responseData > 0) {
                    setShowSuccessModal(true)

                }


                console.log("RespData of" + EditCPTConstants.SaveNewCPTtoList, responseData);
                handleGetCPTList();
                resetDialogValues();


            } else {
                console.error('Error sending data to the API');

            }





        } catch (error) {
            console.error('An error occurred:', error);

        }

    }






    const handleGetCPTList = () => {

        resetDialogValues()

        setLoading(true);
        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.BASE_URL_BILLING}${EditCPTConstants.GetPracticeCPTList}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                setTimeout(() => {
                    setLoading(false);
                    setTableDetails(parsedData);
                    setFilteredTableDetails(parsedData);
                }, 100);
                console.log("Response of" + EditCPTConstants.GetPracticeCPTList, parsedData);


            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }




    useEffect(() => {
        if (!hasFetched) {

            handleGetCPTList();
            setHasFetched(true);
        }
    }, [filteredTableDetails, hasFetched])






    const handleGetCPTServiceData = () => {


        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetCPTServiceData}?sInputJSON=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                console.log("Response of" + CommonAPIConstants.GetCPTServiceData, parsedData);
                setCPTServiceData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    useEffect(() => {

        handleGetCPTServiceData();

    }, [])







    const handleChangeCPTService = (index, e, item) => {
        const selectedValue = e.target.value
        setSelectedService(selectedValue);
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].ServiceID = selectedValue;
        setFilteredTableDetails(updatedRows);
        handleUpdateCPTServiceData(item, selectedValue)

    };



    // Get the Box32AData

    const handleGetBox32AData = () => {


        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetBilling32AData}?sJSONInput=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                console.log("Response of" + CommonAPIConstants.GetBilling32AData, parsedData);
                setBox32AData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    useEffect(() => {

        handleGetBox32AData();

    }, [])







    const handleChangeBillingNPI = (index, e, item) => {
        const selectedValue = e.target.value
        setSelectedBillingNPI(selectedValue);
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].Box32a = selectedValue;
        setFilteredTableDetails(updatedRows);
        handleUpdateBox32AData(item, selectedValue)

    };




    const handleGetBox33AData = () => {


        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetBilling33AData}?sJSONInput=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                console.log("Response of" + CommonAPIConstants.GetBilling33AData, parsedData);
                setCMS33aData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    useEffect(() => {

        handleGetBox33AData();

    }, [])




    const handleCMS33AValue = (index, e, item) => {

        const selectedValue = e.target.value
        setSelectedCMS33a(selectedValue);
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].Box33a = selectedValue;
        setFilteredTableDetails(updatedRows);
        handleUpdateBox33AData(item, selectedValue)
    }





    const handleGetBox33BData = () => {


        var input = {
            PracticeID: userPracticeID
        }

        var sInputJSON = JSON.stringify(input)

        const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetBilling33BData}?sJSONInput=${sInputJSON}`;

        console.log("URL: ", url);

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })
            .then(data => {


                const parsedData = JSON.parse(data)

                console.log("Response of" + CommonAPIConstants.GetBilling33BData, parsedData);
                setCMS33bData(parsedData)

            })
            .catch((error) => {
                console.error('Error fetching:', error);
            });
    }



    useEffect(() => {

        handleGetBox33BData();

    }, [])


    const handleCMS33BValue = (index, e, item) => {

        const selectedValue = e.target.value
        setSelectedCMS33b(selectedValue);
        const updatedRows = [...filteredTableDetails];
        updatedRows[index].Box33b = selectedValue;
        setFilteredTableDetails(updatedRows);
        handleUpdateBox33BData(item, selectedValue)
    }


    const handleEditRow = (index, item) => {
        setEditableRow(index === editableRow ? null : index);
        setselectDescription(item.CPTDescription)
        setselectProjectedFee(item.ProjectedFee)
        setselectCharges(item.Charges)

    };





    // Update the Box32AData

    const handleUpdateBox32AData = async (item, selectedBillingNPI) => {


        const inpuJson = {

            sFeeId: item.FeeID,
            sBoxValue: selectedBillingNPI,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sUserID: userId

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + CommonAPIConstants.UpdateBilling32AData, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.UpdateBilling32AData, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            console.log("Response" + CommonAPIConstants.UpdateBilling32AData, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };



    const handleUpdateBox33AData = async (item, selectedCMS33a) => {


        const inpuJson = {

            sFeeId: item.FeeID,
            sBoxValue: selectedCMS33a,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sUserID: userId

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + CommonAPIConstants.UpdateBilling33AData, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.UpdateBilling33AData, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            console.log("Response" + CommonAPIConstants.UpdateBilling33AData, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };



    const handleUpdateBox33BData = async (item, selectedCMS33b) => {


        const inpuJson = {

            sFeeId: item.FeeID,
            sBoxValue: selectedCMS33b,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sUserID: userId

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + CommonAPIConstants.UpdateBilling33BData, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.UpdateBilling33BData, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            console.log("Response" + CommonAPIConstants.UpdateBilling33BData, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };




    const handleUpdateCPTServiceData = async (item, selectedService) => {


        const inpuJson = {
            sRoleID: selectedService,
            sFeeId: item.FeeID,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sUserID: userId

        }


        const myInput = JSON.stringify(inpuJson);
        const inputData = JSON.stringify(myInput)
        console.log("Input of" + CommonAPIConstants.UpdateCPTServiceData, inputData);

        try {
            const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.UpdateCPTServiceData, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                body: inputData
            })



            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }



            const responseData = await response.json();

            console.log("Response" + CommonAPIConstants.UpdateCPTServiceData, responseData);


        } catch (error) {
            console.error('An error occurred:', error);
        }
    };





    const handleUpdateCPTData = async (item) => {
        const inputJson = {
            sCPTDescription: selectDescription,
            sCPTNewCharge: selectCharges,
            sCPTCode: item.CPT,
            sPracticeID: userPracticeID,
            sProjectedFee: selectProjectedFee,
            sGroupName: "",
            sUserID: userId,
            sBillingFee: Number(item.Charges).toFixed(2)
        };

        const myInput = JSON.stringify(inputJson);
        const sInputJSON = JSON.stringify(myInput);
        console.log("inputRow of " + EditCPTConstants.UpdateCPTtoList, sInputJSON);

        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING + EditCPTConstants.UpdateCPTtoList,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: sInputJSON
                }
            );

            if (response.ok) {
                const responseData = await response.json();



                console.log("RespData of " + EditCPTConstants.UpdateCPTtoList, responseData);

                setEditableRow(null);

                setFilteredTableDetails(prevData =>
                    prevData.map(row =>
                        row.FeeID === item.FeeID
                            ? {
                                ...row,
                                CPTDescription: selectDescription,
                                Charges: selectCharges,
                                ProjectedFee: selectProjectedFee,

                            }
                            : row
                    )
                );
            } else {
                console.error('Error sending data to the API');
            }
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };





    const handleUnitCalculation = async (item, newValue) => {
        const updatedItem = { ...item, UnitCalculation: newValue };

        const inputJson = {
            sFeeID: updatedItem.FeeID,
            sUnitCalculation: newValue,
            sUserID: userId,
            sPracticeID: userPracticeID,
            sCPT: updatedItem.CPT,
        };

        const inputData = JSON.stringify(JSON.stringify(inputJson));
        console.log("Input of " + EditCPTConstants.EditUnitCalculation, inputData);

        try {
            const response = await fetch(
                APIConstants.BASE_URL_BILLING + EditCPTConstants.EditUnitCalculation,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: inputData,
                }
            );

            if (response.status !== 200) {
                console.log("Error: Received response status", response.status);
                return;
            }

            const responseData = await response.json();
            console.log("Response " + EditCPTConstants.EditUnitCalculation, responseData);


            setFilteredTableDetails(prev =>
                prev.map(row =>
                    row.FeeID === updatedItem.FeeID
                        ? { ...row, UnitCalculation: newValue }
                        : row
                )
            );
        } catch (error) {
            console.error('An error occurred:', error);
        }
    };





    const handleEnableYes = () => {
        if (selectedUnitItem) {
            handleUnitCalculation(selectedUnitItem, 1);
            setShowEnableUnitModal(false);
            setSelectedUnitItem(null);
        }
    };

    const handleDisableYes = () => {
        if (selectedUnitItem) {
            handleUnitCalculation(selectedUnitItem, 0);
            setShowDisableUnitModal(false);
            setSelectedUnitItem(null);
        }
    };


    const handleCloseModals = () => {
        // Close all modals
        setErrorMessage('');
        setShowSelectErrorModal(false);
        setShowConfirmSaveModal(false);
       
        setShowEnableUnitModal(false)
        setShowDisableUnitModal(false)
    };






    const handleRowClick = (index) => {
        setActiveRow(index);
    };



     useEffect(() => {
         const filteredData = tableDetails.filter(item => {
             const serviceName = CPTServiceData.find(service => service.ServiceID === item.ServiceID)?.ServiceName || '';
             const box32aName = box32AData.find(b => b.NPI === item.Box32a)?.NamewithNPI || '';
             const box33aName = cms33aData.find(b => b.NPI === item.Box33a)?.NamewithNPI || '';
             const box33bName = cms33bData.find(b => b.TaxonomyCode === item.Box33b)?.NamewithTaxCode || '';

             return (
                 String(item.CPT || '').toLowerCase().includes(searchByCPT.toLowerCase()) &&
                 String(item.CPTDescription || '').toLowerCase().includes(searchByDescription.toLowerCase()) &&
                 String(item.ProjectedFee || '').toLowerCase().includes(searchByFee.toLowerCase()) &&
                 String(item.Charges || '').toLowerCase().includes(searchByCharges.toLowerCase()) &&
                 serviceName.toLowerCase().includes(searchByService.toLowerCase()) &&
                 box32aName.toLowerCase().includes(searchByBox32a.toLowerCase()) &&
                 box33aName.toLowerCase().includes(searchByBox33a.toLowerCase()) &&
                 box33bName.toLowerCase().includes(searchByBox33b.toLowerCase())
             );
         });

         setFilteredTableDetails(filteredData);
     }, [
         searchByCPT,
         searchByDescription,
         searchByFee,
         searchByCharges,
         searchByService,
         searchByBox32a,
         searchByBox33a,
         searchByBox33b,
         tableDetails,
         CPTServiceData,
         box32AData,
         cms33aData,
         cms33bData
     ]);




    const handleSort = (key, accessor) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...filteredTableDetails].sort((a, b) => {
            let aValue = accessor ? accessor(a) : a[key];
            let bValue = accessor ? accessor(b) : b[key];


            if (aValue == null) aValue = 0;
            if (bValue == null) bValue = 0;


            if (key.toLowerCase().includes('date') || key.toLowerCase().includes('dob') || key.toLowerCase().includes('dos')) {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            else if (!isNaN(aValue) && !isNaN(bValue)) {
                aValue = parseFloat(aValue) || 0;
                bValue = parseFloat(bValue) || 0;
            }

            else if (typeof aValue === 'string') {
                aValue = aValue.toUpperCase();
                bValue = typeof bValue === 'string' ? bValue.toUpperCase() : '';
            }

            if (aValue < bValue) return direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setSortConfig({ key, direction });
        setFilteredTableDetails(sortedData);
    };




    return (


        <>

            <div style={{ height: 'auto', marginLeft: '10px', backgroundColor: 'white', width: '100%', border: '1px solid blue', marginTop: '20px' }}>



                <div style={{ height: 'auto', marginTop: '10px', width: '100%' }}>

                    <label style={{ marginLeft: '10px', marginTop: '0px', fontWeight: 'bold', fontSize: '1.4rem' }} onClick={handleGetCPTList}>Add New CPT</label>


                    <div className='macroname-container'>

                        <label style={{ fontSize: '1.2rem' }} onClick={handleGetBox33BData}>CPT Code:</label>

                        <div>
                            <input style={{ height: '30px', borderRadius: '5px', borderColor: 'gray' }} type='text'
                                placeholder='CPT'
                                value={selectedCptValue}
                                onChange={(e) => setSelectedCptValue(e.target.value)}
                                onKeyUp={handleCPTKeyDown}
                            />

                            <div style={{ position:'absolute', zIndex: 9999 }}>
                                <ul className='cptsugg-list' style={{ width: '220px', color: 'black', fontSize: '1rem' }}>
                                    {Array.isArray(cptValueList) && cptValueList.map((suggestion) => (
                                        <li key={suggestion.val} onClick={() => handleCPTList(suggestion)}>
                                            {suggestion.CPTCode}-{suggestion.CPTDesc}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                        </div>



                        <label style={{ marginLeft: '90px', fontSize: '1.2rem' }}>Description:</label>

                        <input style={{ marginLeft: '10px', height: '30px', borderRadius: '5px' }} type='text'
                            value={cptdescription}
                            onChange={(e) => setCptDescription(e.target.value)}
                        />


                        <label style={{ marginLeft: '90px', fontSize: '1.2rem' }}>Charges:</label>

                        <input style={{ marginLeft: '10px', height: '30px', borderRadius: '5px' }} type='text'
                            value={cptCharges}
                            onChange={(e) => setCptCharges(e.target.value)}
                        />


                        <button
                            className='diagbtn-style'
                            style={{ marginLeft: '100px', width: '80px' }}
                            onClick={handleSaveCPTData}
                        >
                            Save
                        </button>


                    </div>



                </div>


                {loading && (
                    <div className="overlay">
                        <div className="spinner-container">
                            <div className="spinner-grow text-danger" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <div className="spinner-grow text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                )}



                <div style={{ height: 'auto', border: '2px solid lightgray', marginTop: '20px', width: '100%' }}>



                    <table className="table table-hover table-striped table-primary table-bordered border-white responsive mt-2 fixed-header " style={{ marginLeft: '1px', width: '100%' }}>

                        <thead>

                            <tr className='align-top' style={{ fontSize: '0.5rem' }}>

                                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7' }}>#</th>

                                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }} >
                                    <Link className='text-white' onClick={() => handleSort('CPT')}>CPT Code</Link>
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        className='hide-on-print'
                                        value={searchByCPT}
                                        onChange={(e) => setSearchByCPT(e.target.value)}
                                    />

                                </th>

                                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '140px' }}>

                                    <Link className='text-white' onClick={() => handleSort('CPTDescription')}>Description</Link>
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        className='hide-on-print'
                                        value={searchByDescription}
                                        onChange={(e) => setSearchByDescription(e.target.value)}
                                    />

                                </th>
                                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>
                                    <Link className='text-white' onClick={() => handleSort('ProjectedFee')}>Projected Fee</Link>
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        className='hide-on-print'
                                        value={searchByFee}
                                        onChange={(e) => setSearchByFee(e.target.value)}
                                    />
                                </th>

                                <th className='col-sm col-th  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '90px' }}>

                                    <Link className='text-white' onClick={() => handleSort('Charges')}>Charges</Link>
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        className='hide-on-print'
                                        value={searchByCharges}
                                        onChange={(e) => setSearchByCharges(e.target.value)}
                                    />

                                </th>



                                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>

                                    <Link className='text-white' onClick={() => handleSort('ServiceID')}>Service</Link>
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        className='hide-on-print'
                                        value={searchByService}
                                        onChange={(e) => setSearchByService(e.target.value)}
                                    />
                                </th>
                                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>

                                    <Link className='text-white' onClick={() => handleSort('Box32a')}> Box 32a</Link>
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        className='hide-on-print'
                                        value={searchByBox32a}
                                        onChange={(e) => setSearchByBox32a(e.target.value)}
                                    />
                                </th>
                                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>

                                    <Link className='text-white' onClick={() => handleSort('Box33a')}> Box 33a</Link>
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        className='hide-on-print'
                                        value={searchByBox33a}
                                        onChange={(e) => setSearchByBox33a(e.target.value)}
                                    />
                                </th>
                                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>

                                    <Link className='text-white' onClick={() => handleSort('Box33b')}>Box 33b</Link>
                                    <br />
                                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                        className='hide-on-print'
                                        value={searchByBox33b}
                                        onChange={(e) => setSearchByBox33b(e.target.value)}
                                    />
                                </th>
                                <th className='col col-th-style  text-white border border-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>Action

                                </th>


                            </tr>

                        </thead>

                        <tbody>
                            {filteredTableDetails.map((item, index) => (
                                <tr className={`${activeRow === index ? "table-warning" : ""}`}
                                    key={index}
                                    onClick={() => handleRowClick(index)}>
                                    <th>{index + 1}</th>
                                    <td>
                                        <div className='d-flex'>
                                            <label>{item.CPT}</label>
                                            <div className="form-check form-switch"
                                              title={item.UnitCalculation === 1 ? 'Unit Calculation is ON' : 'Unit Calculation is OFF'}
                                            >
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id={`switchCheckDefault-${item.FeeID}`}
                                                    checked={item.UnitCalculation === 1}
                                                    onChange={() => {
                                                        setSelectedUnitItem(item);
                                                        item.UnitCalculation === 1
                                                            ? setShowDisableUnitModal(true)
                                                            : setShowEnableUnitModal(true);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                    </td>
                                    <td>
                                        {editableRow === index ? (
                                            <input type="text" className="form-control"

                                                value={selectDescription}
                                                onChange={(e) => setselectDescription(e.target.value)}
                                            />
                                        ) : (
                                            <label>{item.CPTDescription}</label>
                                        )}
                                    </td>
                                    <td>

                                        {editableRow === index ? (
                                            <input type="number" className="form-control"

                                                value={selectProjectedFee}
                                                onChange={(e) => setselectProjectedFee(e.target.value)}
                                            />
                                        ) : (
                                            <label>{Number(item.ProjectedFee).toFixed(2)}</label>
                                        )}
                                    </td>
                                    <td>
                                        {editableRow === index ? (
                                            <input type="number" className="form-control"
                                                value={selectCharges}
                                                onChange={(e) => setselectCharges(e.target.value)}
                                            />
                                        ) : (
                                            <label>{Number(item.Charges).toFixed(2)}</label>
                                        )}
                                    </td>

                                    <td>

                                        <select name="select" id="" className='option3 input'
                                            value={item.ServiceID}
                                            onChange={(e) => handleChangeCPTService(index, e, item)}
                                        >

                                            <option value="-1" >
                                                &lt;--Select--&gt;
                                            </option>
                                            {CPTServiceData.map((item, index) => (
                                                <option key={index} value={item.ServiceID}>{item.ServiceName}</option>

                                            ))}
                                        </select>

                                    </td>
                                    <td>
                                        <select name="select" id="" className='option3 input'
                                            value={item.Box32a}
                                            onChange={(e) => handleChangeBillingNPI(index, e, item)}
                                        >

                                            <option value="0" >
                                                &lt;--Select--&gt;
                                            </option>
                                            {box32AData.map((item, index) => (
                                                <option key={index} value={item.NPI}>{item.NamewithNPI}</option>

                                            ))}
                                        </select>

                                    </td>
                                    <td>
                                        <select name="select" className='select-style2 input'
                                            value={item.Box33a}
                                            onChange={(e) => handleCMS33AValue(index, e, item)}>
                                            {cms33aData.map((item, index) => (
                                                <option key={index} value={item.NPI}>{item.NamewithNPI}</option>

                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <select name="select" id="" className='option2 input'
                                            value={item.Box33b}
                                            onChange={(e) => handleCMS33BValue(index, e, item)}>
                                            {cms33bData.map((item, index) => (
                                                <option style={{ width: "100px" }} key={index} value={item.TaxonomyCode}>
                                                    {item.NamewithTaxCode}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        {editableRow === index ? (
                                            <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px', fontSize: '1.4rem' }} onClick={() => handleUpdateCPTData(item)} icon={faFloppyDisk} />
                                        ) : (
                                            <>
                                                <FontAwesomeIcon style={{ cursor: 'pointer', marginLeft: '5px', fontSize: '1.2rem' }} onClick={() => handleEditRow(index, item)} icon={faPencil} />

                                            </>
                                        )}
                                    </td>

                                </tr>

                            ))}



                        </tbody>

                    </table>




                    {showSelectErrorModal && (

                        <div className='alertcpt-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>CPT Already Present!!</p>

                        </div>

                    )}



                    {showConfirmSaveModal && (

                        <div className='alertcpt-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>No or Invalid CPT Entry Found...</p>

                        </div>

                    )}



                    {showEnableUnitModal && (
                        <div className='cptunit-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>Are you sure you want to Enable Unit Calculation?</p>
                            <button className='btn-style3' style={{ fontSize: '1.2rem' }} onClick={handleEnableYes}>Yes</button>
                            <button className='btn-style3' style={{ fontSize: '1.2rem' }} onClick={handleCloseModals}>No</button>
                        </div>
                    )}

                    {showDisableUnitModal && (
                        <div className='cptunit-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>Are you sure you want to Disable Unit Calculation?</p>
                            <button className='btn-style3' style={{ fontSize: '1.2rem' }} onClick={handleDisableYes}>Yes</button>
                            <button className='btn-style3' style={{ fontSize: '1.2rem' }} onClick={handleCloseModals}>No</button>
                        </div>
                    )}



                </div>








            </div>


        </>
    )
}

export default EditCpt